import { render } from "./Navigation.vue?vue&type=template&id=36bea6fc&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=36bea6fc&scoped=true&lang=css"

import exportComponent from "/Users/warths/refonte-manager-cli/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36bea6fc"]])

export default __exports__